import {useDebugValue} from 'react';

import {useValues} from './';

const defaultSearchValues = {
    filters: []
};

function useSearchValues(props) {
    const {
        searchValues: propsSearchValues
    } = props;

    const {
        initialValues: initialSearchValues,
        currentValues: currentSearchValues,
        latestValues: latestSearchValues,
        setCurrentValues: setCurrentSearchValues,
        setCurrentValuesDefault: setCurrentSearchValuesDefault,
        setCurrentValuesInitial: setCurrentSearchValuesInitial,
        setCurrentValuesLatest: setCurrentSearchValuesLatest,
        setLatestValues: setLatestSearchValues,
        setLatestValuesDefault: setLatestSearchValuesDefault,
        setLatestValuesInitial: setLatestSearchValuesInitial,
        setLatestValuesCurrent: setLatestSearchValuesCurrent,
        setAllValues: setAllSearchValues,
        setAllValuesDefault: setAllSearchValuesDefault,
        setAllValuesInitial: setAllSearchValuesInitial
    } = useValues(defaultSearchValues, propsSearchValues);

    const result = {
        defaultSearchValues,
        initialSearchValues,
        currentSearchValues,
        latestSearchValues,
        setCurrentSearchValues,
        setCurrentSearchValuesDefault,
        setCurrentSearchValuesInitial,
        setCurrentSearchValuesLatest,
        setLatestSearchValues,
        setLatestSearchValuesDefault,
        setLatestSearchValuesInitial,
        setLatestSearchValuesCurrent,
        setAllSearchValues,
        setAllSearchValuesDefault,
        setAllSearchValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useSearchValues};
